import type { DefaultValues, SubmitHandler } from 'react-hook-form';
import { Labeled } from '@sixui/ui';
import { useForm } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';

import type { IContentBlockFormBodyProps } from '~/components/molecules/ContentBlock';
import type { IContainerProps } from '~/components/utils/Container';
import type { IFormMode } from '~/helpers/types';
import { FormField } from '~/components/atoms/FormField';
import { Link } from '~/components/atoms/Link';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { OrganizationSelector } from '~/components/organisms/fields/OrganizationSelector';

export type IAppOrganizationFormValues = {
  organizationId: string;
};

export type IAppOrganizationFormProps = IContainerProps &
  Omit<
    IContentBlockFormBodyProps<IAppOrganizationFormValues>,
    'form' | 'children' | 'onSubmit' | 'submitting'
  > & {
    mode: IFormMode;
    defaultValues?: DefaultValues<IAppOrganizationFormValues>;
    onSubmit?: SubmitHandler<IAppOrganizationFormValues>;
  };

export const AppOrganizationForm: React.FC<IAppOrganizationFormProps> = (
  props,
) => {
  const { sx, defaultValues, onSubmit, ...other } = props;
  const form = useForm<IAppOrganizationFormValues>({ defaultValues });
  const { t } = useTranslation();

  return (
    <ContentBlock.FormBody
      sx={sx}
      form={form}
      onSubmit={onSubmit}
      submitButtonLabel={t('AppOrganizationForm.submit')}
      {...other}
    >
      <Trans parent="p" i18nKey="AppOrganizationForm.p1" />
      <Trans
        parent="p"
        i18nKey="AppOrganizationForm.p2"
        components={{
          a: <Link to="/organizations/create" />,
        }}
      />
      <Labeled label="Select a new account">
        <FormField
          name="organizationId"
          control={form.control}
          as={OrganizationSelector}
          forwardError
          allowPersonalAccount
        />
      </Labeled>
    </ContentBlock.FormBody>
  );
};
